import React from 'react';
import { Grid } from '@material-ui/core';

import SubTaskListCard from '../../tasks/cards/SubTaskListCard';
import TaskAttachmentCard from '../../tasks/cards/TaskAttachmentCard';
import TaskFileListCard from '../../tasks/cards/TaskFileListCard';
import TaskStatusCard from '../../tasks/cards/TaskStatusCard';
import { Task } from '../../tasks/Task.interface';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import TrainingAssignChangeOrdersCard from '../cards/TrainingAssignChangeOrdersCard';
import TrainingAssignedGroupCard from '../cards/TrainingAssignedGroupCard';
import TrainingInfoCard from '../cards/TrainingInfoCard';
import TrainingRecurringCard from '../cards/TrainingRecurringCard';
import TrainingVersionCard from '../cards/TrainingVersionCard';
import { BaseTrainingCardProps } from '../Training.interface';
import TrainingSendEmailReminderCard from '../cards/TrainingSendEmailReminderCard';

const TrainingTabInfo: React.FC<BaseTrainingCardProps> = (
  props: BaseTrainingCardProps
) => {
  const { training } = props;
  const { isFieldDisabled } = useTaskEntityFields(training?.task);

  const handleTaskUpdate = (newTask: Partial<Task>) => {
    Object.assign(training.task, newTask);
    props.onChange?.({});
    props.onUpdate?.();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TrainingInfoCard {...props} />
          </Grid>
          <Grid item xs={12}>
            <TrainingAssignedGroupCard training={training} />
          </Grid>
          <Grid item xs={12}>
            <TaskAttachmentCard
              task={training.task}
              onError={props.onError}
              onChange={handleTaskUpdate}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          {training.task && (
            <>
              <Grid item xs={12}>
                <TaskStatusCard task={training.task} />
              </Grid>
              {/* has at least 1 approved version */}
              {training.version > 1 && (
                <Grid item xs={12}>
                  <TrainingSendEmailReminderCard training={training} />
                </Grid>
              )}
              <Grid item xs={12}>
                <SubTaskListCard
                  task={training.task}
                  title='Stakeholders'
                  disabled={isFieldDisabled('assignSubTasks')}
                  onError={props.onError}
                  onChange={handleTaskUpdate}
                />
              </Grid>
              <Grid item xs={12}>
                <TaskFileListCard
                  task={training.task}
                  onError={props.onError}
                  onChange={handleTaskUpdate}
                />
              </Grid>
              <Grid item xs={12}>
                <TrainingAssignChangeOrdersCard {...props} />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <TrainingVersionCard training={training} />
          </Grid>
          <Grid item xs={12}>
            <TrainingRecurringCard {...props} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TrainingTabInfo;
